<template>
    <el-dialog :close-on-click-modal="false" :show-close="false" class="laft-dialog" title="Importante">
        <el-row style="margin-bottom: 0;">
            <el-col style="color:#706262;">
                <p class="ParrafosPopUp">
                    Para poder {{ textoBoton }} con el proceso es necesario leer y marcar el check de buenas prácticas y
                    compromisos LAFT:
                </p>
            </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px;">
            <el-col style="color:#706262">
                <div class="checkbox-container">
                    <el-checkbox v-model="checkLAFT" class="checkBoxLaft"></el-checkbox>
                    <span>
                        Se da cumplimiento de buenas prácticas y compromisos LAFT*
                        <strong><a @click="obtenerDocumentoLAFT('Declaración de compromiso en prevención de LAFTFPADM y cumplimiento de buenas prácticas.pdf')"
                                class="link-modal">Leer</a></strong>
                    </span>
                </div>
                <div v-if="obligatorio" style="color: #f68b1e; word-break: keep-all;">
                    <p><strong>*No es posible continuar hasta no leer y aceptar las buenas practicas y compromisos LAFT.</strong>
                    </p>
                </div>
            </el-col>
        </el-row>
        <span class="botonFinalizar">
            <el-button type="success" plain @click="Validarcheck()">{{ textoBoton }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { computed, ref } from "@vue/reactivity";
import { useStore } from "vuex";
import NivelRiesgo from "@/models/DueDiligence/NivelRiesgo";
import '../../../assets/sass/components/DueDiligence/_laft.scss';

export default{
    name: 'PopUpCompromisosLAFT',
    setup(props,{emit}) {
        const store = useStore();
        const checkLAFT = ref(false);
        const clickBoton = ref(false);
        const obligatorio = computed(() => !checkLAFT.value && clickBoton.value);
        const textoBoton = computed(() => store.state.ddModule.calculoNivelRiesgo.nivel == NivelRiesgo.Extremo
            ? "continuar" : "finalizar");

        function Validarcheck() {
            clickBoton.value = true;
            if (checkLAFT.value) {
                aprobarLAFT();
            }
        }

        function aprobarLAFT() {
            emit(store.state.ddModule.calculoNivelRiesgo.nivel == NivelRiesgo.Extremo
                ? 'AvanzarFinanciera'
                : 'FinalizarDebidaDiligencia'
            );
        };

        const obtenerDocumentoLAFT = (nombreArchivo) => {
            const url =
                process.env.VUE_APP_Gateway_API + "DebidaDiligencia/DescargarArchivoBlobStorage?nombre=" + nombreArchivo;
            window.open(url, "_blank");
        };

        return {
            store,
            obligatorio,
            Validarcheck,
            obtenerDocumentoLAFT,
            checkLAFT,
            textoBoton,
            clickBoton
        };
    }
};
</script>
